// -------------------------------------------
//--STRING MANIPULATION
// -------------------------------------------


export const capitalizeFirstLetterEachWord = (str) => {
  return str?.replace(/\b\w+/g, word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
};

export const TruncateText = (str) => {
  const text = str.length > 500 && '...see details';
  return text;
}




// ---------------------------------------------------------
// URL TRANSFORMATION
// ---------------------------------------------------------

export function NormalizeSlugs(str) {
    // if (typeof str !== 'string') return ''; // NEW
  return str
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')  // Replace spaces with dashes
    .replace(/[^\w-]+/g, '');  // Remove all non-word characters
}



export const GenerateProductURL = (category, productTitle) => {
  const encodedTitle = encodeURIComponent(productTitle);
  return `/appliances/${category}/${encodedTitle}`;
};

export const homeLink = '/';
export const homeDepotRoot = `/home-depot/`
export const portalLink = `/portal/dashboard`;



// ---------------------------------------------------------
// PRODUCTS
// ---------------------------------------------------------

export const FilterProductById = (products, productId) => {
  return products.filter(product => product.title === productId);
};

// export const consolidateSpecListsToArray = (product) => {
//   console.log(product)
//   let consolidatedList = [];
  
//   // List of spec keys to extract and consolidate
//   const specLists = ['specList1', 'specList2', 'specList3', 'specList4'];

//   // Iterate through each spec list in the product and concatenate it to the consolidatedList
//   specLists.forEach(specList => {
//     // console.log(specList)
//     // if (Array.isArray(product[specList]) && product[specList].length > 0) {
//     //   consolidatedList = consolidatedList.concat(product[specList]);
//     // }
//      if ( product && Array.isArray(product[specList]) && product[specList].length > 0) {
//       consolidatedList = consolidatedList.concat(product[specList]);
//     }
//   });

//   return consolidatedList;
// };

export const consolidateSpecListsToArray = (product) => {
  if (!product || typeof product !== "object") return [];

  const consolidatedList = [];

  const specLists = ['specList1', 'specList2', 'specList3', 'specList4'];

  for (const key of specLists) {
    const list = product[key];
    if (Array.isArray(list) && list.length > 0) {
      consolidatedList.push(...list);
    }
  }

  return consolidatedList;
};


// export const extractProductNamesFromKeywords = (keywords) => {
//   const productNames = [];
//   const targetKeywords = new Set(['related','optional', 'matching', 'accessories']);
//   const regex = /\(([^)]+)\)/g;

//   keywords.forEach(keyword => {
//     const lowerCaseKeyword = keyword.toLowerCase();

//     // Check if the line contains one of the target keywords
//     if ([...targetKeywords].some(target => lowerCaseKeyword.includes(target))) {
//       let match;

//       // Extract product names from within brackets
//       while ((match = regex.exec(keyword)) !== null) {
//         const names = match[1].split(',').map(name => name.trim());
//         productNames.push(...names);
//       }

//       // Extract product name from the end of the line (last word)
//       const words = keyword.trim().split(' ');
//       const productName = words[words.length - 1];
//       productNames.push(productName);
//     }
//   });

//   return productNames;
// };


export const extractProductNamesFromKeywords = (keywords = []) => {
  const productNames = [];

  const targetKeywords = [
    "related",
    "optional",
    "matching",
    "accessories",
    "compatible",

    "associé",
    "associée",
    "associés",
    "associées",
    "optionnel",
    "optionnelle",
    "optionnels",
    "optionnelles",
    "correspondant",
    "correspondante",
    "accessoire",
    "accessoires",
    "compatible",
    "compatibles",

    // CUSTOM:

    "assorties",
    "assorti"
  ];

  const bracketRegex = /\(([^)]+)\)/g;

  keywords.forEach((keyword) => {
    if (typeof keyword !== "string") return;

    const lowerCaseKeyword = keyword.toLowerCase();

    const hasTargetKeyword = targetKeywords.some((target) =>
      lowerCaseKeyword.includes(target)
    );

    if (!hasTargetKeyword) return;

    let match;

    while ((match = bracketRegex.exec(keyword)) !== null) {
      const names = match[1]
        .split(",")
        .map((name) => name.trim())
        .filter(Boolean);

      productNames.push(...names);
    }
  });

  return [...new Set(productNames)];
};

export const findMatchingProducts = (productNames = [], productList = []) => {
  if (!Array.isArray(productList)) {
    console.error("productList is not an array or is undefined");
    return [];
  }

  const normalizedNameSet = new Set(
    productNames
      .map((name) => String(name || "").trim().toLowerCase())
      .filter(Boolean)
  );

  return productList.filter((product) =>
    normalizedNameSet.has(String(product.title || "").trim().toLowerCase())
  );
};


// export const findMatchingProducts = (productNames, productList) => {

//   if (!Array.isArray(productList)) {
//     console.error('productList is not an array or is undefined');
//     return [];
//   }
//   const nameSet = new Set(productNames);
//   return productList.filter(product => nameSet.has(product.title));
// };

//SORT PRODUCT TITLE AND MSRP


export const sortProductsByMsrpAndTitle = (products) => {
  // Check if the input is an object
  if (typeof products === 'object' && products !== null) {
    // Iterate over each category key in the object
    Object.keys(products).forEach((category) => {
      // Access and sort the array of products under each category
      if (Array.isArray(products[category])) {
        products[category].sort((a, b) => {
          // Convert MSRP to a float, defaulting to null for non-numeric values
          const msrpA = a.msrp !== null && a.msrp !== '' && !isNaN(a.msrp) ? parseFloat(a.msrp) : null;
          const msrpB = b.msrp !== null && b.msrp !== '' && !isNaN(b.msrp) ? parseFloat(b.msrp) : null;

          // If both products have a valid MSRP, sort by MSRP descending
          if (msrpA !== null && msrpB !== null) {
            return msrpB - msrpA;
          }

          // If only one has a valid MSRP, place that one first
          if (msrpA !== null) return -1;
          if (msrpB !== null) return 1;

          // If neither has a valid MSRP, sort by title alphabetically
          const titleA = a.title ? a.title.replace(/[^a-zA-Z]/g, '').toLowerCase() : '';
          const titleB = b.title ? b.title.replace(/[^a-zA-Z]/g, '').toLowerCase() : '';
          return titleA.localeCompare(titleB);
        });
      }
    });
    return products;
  } else {
    // If products is not an object, return it as is
    // console.log('not an object or invalid format');
    return products;
  }
};





export const ListProductsByCategorySubcategory = (products) => {
  return products.reduce((acc, product) => {
    if (!acc[product.category]) {
      acc[product.category] = {};
    }
    if (!acc[product.category][product.subcategory]) {
      acc[product.category][product.subcategory] = [];
    }
    acc[product.category][product.subcategory].push(product);
    return acc;
  }, {});
};

export const NormalizeCategoryId = (categoryId) => {
  const adjustments = {
    'air-care': 'air care',
  };
  return adjustments[categoryId] || categoryId;
};

export const FilterProductsByCategoryId = (products, categoryId) => {
  if (Array.isArray(products)) {
    return products.filter(product => product.category === categoryId);
  } else {
    console.error('FilterProductsByCategoryId: products is not an array', products);
    return [];
  }
}



// PORTAL
export const formatChartLabel = (label) => {
  if (!label || typeof label !== 'string') {
    return 'Unknown'; // Default to 'Unknown' or another fallback
  }
  return label
    .replace(/_/g, ' ')                                  // Replace underscores with spaces
    .replace(/\b\w/g, char => char.toUpperCase());        // Capitalize first letter of each word
};



// -------------------------------------------
//--PAGE PATH
// -------------------------------------------
export const categorizePagePath = (pagePath) => {
  // Root homepage
  if (pagePath === '/') return 'Homepage';

  // Handle undefined or non-string values gracefully
  if (!pagePath || typeof pagePath !== 'string') return 'Unknown Page';

  // Appliances paths (Root)
  if (pagePath.startsWith('/appliances/')) {
    const segments = pagePath.split('/').filter(Boolean);

    if (segments.length === 1) {
      return 'All Category Page'; // /appliances/
    } else if (segments.length === 2) {
      return 'Category Page'; // /appliances/category-name
    } else if (segments.length >= 3) {
      const productSegment = segments[2];

      // Handle URLs with multiple product names separated by slashes or underscores
      const hasMultipleProducts = productSegment.includes('/') || productSegment.includes('_');

      if (hasMultipleProducts) {
        return 'Product Page (Multiple Products)'; // Example: /appliances/signature/DLEX9500K / DLGX9501K
      }

      return 'Product Page'; // Default for a single product page
    }
  }

  // Step-Up Chart path (Root)
  if (pagePath.startsWith('/step-up-chart/')) {
    return 'Step-Up Chart';
  }

  // Resource pages (Root)
  if (['/resources/definitions', '/resources/warranties'].includes(pagePath)) {
    return 'Resource Page';
  }

  // Product List Builder page (Root)
  if (pagePath === '/product-list') {
    return 'Product List Builder';
  }

  // Home Depot paths
  if (pagePath.startsWith('/home-depot/')) {
    const segments = pagePath.split('/').filter(Boolean);

    // Home Depot homepage
    if (segments.length === 1) {
      return 'Home Depot Home Page';
    }

    // Home Depot appliances paths
    if (segments[1] === 'appliances') {
      if (segments.length === 2) {
        return 'Home Depot All Category Page'; // /home-depot/appliances/
      } else if (segments.length === 3) {
        return 'Home Depot Category Page'; // /home-depot/appliances/category-name
      } else if (segments.length >= 4) {
        const productSegment = segments[3];

        // Handle URLs with multiple product names separated by slashes or underscores
        const hasMultipleProducts = productSegment.includes('/') || productSegment.includes('_');

        if (hasMultipleProducts) {
          return 'Home Depot Product Page (Multiple Products)'; // Example: /home-depot/appliances/signature/DLEX9500K / DLGX9501K
        }

        return 'Home Depot Product Page'; // Default for a single product page
      }
    }

    // Home Depot Step-Up Chart paths
    if (segments[1] === 'step-up-chart') {
      return 'Home Depot Step-Up Chart'; // /home-depot/step-up-chart/chart-name
    }

    // Home Depot Resource pages
    if (['resources/definitions', 'resources/warranties'].includes(segments[1])) {
      return 'Home Depot Resource Page';
    }

    // Home Depot Product List Builder page
    if (segments[1] === 'product-list') {
      return 'Home Depot Product List Builder';
    }
  }

  // Fallback for unknown pages

  return 'Unknown Page';
};
export const categorizeAppliancePath = (pagePath) => {
  // Predefined categories (manual mapping)
  // if (pagePath.includes('/appliances/air-care/')) {
  //   return 'Air Care';
  // }
  if (pagePath.includes('/appliances/Cooking/')) {
    return 'Cooking';
  }
  if (pagePath.includes('/appliances/Dishwasher/')) {
    return 'Dishwashers';
  }
  if (pagePath.includes('/appliances/Laundry')) {
    return 'Laundry';
  }
  if (pagePath.includes('/appliances/Refrigeration/')) {
    return 'Refrigeration';
  }
  if (pagePath.includes('/appliances/LG%20Studio/')) {
    return 'Studio';
  }

  // Dynamic handling for unknown categories
  const regex = /\/appliances\/([a-zA-Z0-9_-]+)\//;
  const match = pagePath.match(regex);
  return match ? match[1] : 'Unknown Category';
};

export function isEmptyList(list) {
  // If not an array or falsy, treat as empty
  if (!Array.isArray(list) || list.length === 0) return true;

  // Filter out empty strings and null-like values
  const cleaned = list.filter(item => {
    if (typeof item === 'string') {
      return item.trim() !== '';
    }
    return item != null; // keeps numbers, objects, etc.
  });

  return cleaned.length === 0;
}
